// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedOutDiscoveryPage-cls1_QcK","cls2":"LoggedOutDiscoveryPage-cls2_76X LoggedOutDiscoveryPage-cls1_QcK"};